export const publicationNotificationRoute = (publicationId) =>
  `/publicidad?tab=publicaciones&publicationId=${encodeURIComponent(publicationId)}`;

export const eventNotificationRoute = (eventItem = {}) =>
  eventItem.publicationId
    ? publicationNotificationRoute(eventItem.publicationId)
    : '/notificaciones';
